export default {"src":"/_next/static/media/gray-calendar.eed0657e.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};